<template>
  <div class="content order-list list report-list">
    <div class="row">
      <div class="col-sm-12">
        <el-card>
          <h4 style="color: #3b291d">My Task List</h4>
          <div class="row" style="margin-top: 20px">
            <div class="col-sm-12" style="display: flex">
              <span
                style="
                  margin-left: auto;
                  line-height: 32px;
                  padding-right: 20px;
                "
              >
                Total No. of Record: {{ searchKey.total }}
                <base-pagination
                  class="pagination-no-border"
                  v-model="searchKey.pageIndex"
                  :total="searchKey.total"
                  :pagesToDisplay="10"
                  style="float: right"
                  :value="searchKey.pageIndex"
                  @changePage="ChangePageSearch"
                  @nextPage="ChangePageSearch"
                >
                </base-pagination>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <el-table
                :data="orderlist"
                style="width: 100%"
                border
                header-row-class-name="header-row"
                @filter-change="filterChange"
                table-layout="auto"
                cell-class-name="report-cell"
              >
                <el-table-column prop="unit" label="Unit" :width="70" />
                <tablecolumn
                  prop="orderNumber"
                  label="Order No."
                  :width="140"
                />
                <tablecolumn
                  prop="contractingParty"
                  label="Contracting Party"
                  :width="230"
                />
                <tablecolumn
                  prop="contractNumber"
                  label="Contract No."
                  :width="200"
                />
                <tablecolumn
                  prop="advertiser"
                  label="Advertiser"
                  :width="230"
                />
                <tablecolumn
                  prop="product"
                  label="Product"
                  :width="0"
                  min-width="150"
                />
                <el-table-column
                  prop="startDate"
                  label="Campaign Start"
                  :formatter="formatterCellDate"
                  :width="120"
                />
                <el-table-column
                  prop="endDate"
                  label="Campaign End"
                  :formatter="formatterCellDate"
                  :width="120"
                />
                <el-table-column
                  prop="totalAmount"
                  :formatter="formatterCellMoney"
                  label="Total Amount"
                  :width="130"
                />
                <tablecolumn prop="salesman" label="Salesman" :width="140" />
                <el-table-column
                  prop="createDate"
                  label="Created Date"
                  :formatter="formatterCellDateTime"
                  :width="160"
                />
                <el-table-column
                  prop="status"
                  label="Status"
                  :filters="typeList.StatusTypeList"
                  filter-placement="bottom-end"
                  :width="110"
                  column-key="StatusTypes"
                />
                <el-table-column
                  prop=""
                  fixed="right"
                  label="Action"
                  :width="80"
                  class-name="action"
                >
                  <template #default="scope">
                    <el-button type="text" @click="openpage('view', scope.row)"
                      ><el-icon :size="18" style="color: #303133">
                        <Search /> </el-icon
                    ></el-button>
                    <el-button
                      type="text"
                      @click="openpage('edit', scope.row)"
                      v-if="scope.row.isWrite"
                      style="color: #303133"
                    >
                      <el-icon :size="18"> <Edit /> </el-icon
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div></div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
// import './css/index.css';
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';
import { routeParamsStore } from '@/store/routeParams';

// router
import router from '@/router';
import booknet from '@/network/booknet';

// api
import basicapi from '@/network/optional';

// icon
import { Edit, Search } from '@element-plus/icons-vue';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';

const useParam = routeParamsStore();

const typeList = reactive({
  StatusTypeList: [
    { text: 'Open', value: 'Open' },
    { text: 'WIP', value: 'WIP' },
    { text: 'Completed', value: 'Completed' },
    { text: 'Void', value: 'Void' },
  ],
});
//变更分页
const ChangePageSearch = async (data) => {
  searchKey.pageIndex = data;
  search();
};
//搜索条件实体
const searchKey = reactive({
  pageIndex: 1,
  pageSize: 10,
});

const SalesList = ref([]);
const AdvertiserOptionals = ref([]);

// #region datas
const orderlist = ref([]);
// #endregion

onBeforeMount(async () => {
  useParam.home = 'myTask';
  // 读取基本的Option
  const optionals1 = await booknet.GetOrderSalesmanList().then((res) => res);
  // 销售员选项
  SalesList.value = optionals1.data;

  // ContractingParty
  var result = await booknet.GetOrderContractingPartyList().then((res) => res);
  AdvertiserOptionals.value = result.data;

  await search();
});

const openpage = (type, order) => {
  //设置参数传值

  useParam.orderParams = {
    OrderNo: order.orderNumber,
    mode: type,
    id: order.id,
  };
  // useParam.home = 'myTask';

  // 更新页面参数
  useParam.setPageParam({
    key: order.orderNumber,
    mode: type,
  });

  window.open(`order?OrderNo=${order.orderNumber}`);
  // router.push({
  //   name: 'order',
  //   query: {
  //     OrderNo: order.orderNumber,
  //   },
  //   params: {
  //     mode: type,
  //     id: order.id,
  //   },
  // });
};

// event: Search
const search = async () => {
  const search_res = await booknet.GetMyTaskList(searchKey).then((res) => res);
  searchKey.total = search_res.data.total;
  orderlist.value = search_res.data.list;
};
//重置筛选条件
const reset = async () => {
  //清空对象
  Object.keys(searchKey).map((key) => {
    delete searchKey[key];
  });
  searchKey.pageIndex = 1;
  searchKey.pageSize = 10;
  search();
};
const filterChange = async (filters) => {
  if (filters.StatusTypes) {
    searchKey.statusTypes = filters.StatusTypes;
  }
  await search();
};

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    // 动态赋值
    searchKey[`${data.key}`] = data.value;
    search();
  });
});
</script>

<style scoped>
.orderlist {
  font-size: 13px;
}

.searchs {
  width: 1213px;
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;
}

.searchs-item {
  line-height: 2.1rem;
  display: flex;
}

.searchs-item .searchs-item-control {
  padding: 0 50px 0 10px;
}

.filter-cell {
  height: 32px;
}

.filter-cell-title {
  padding: 5px 0;
}

.filter-cell-icon {
  position: absolute;
  top: 0;
  right: 12px;
}

.filter-cell-control {
  min-width: 230px;
}

.el-pagination {
  float: right;
}
</style>
<style>
.orderlist .report-cell .cell {
  word-break: break-word;
}

.range-picker .el-date-editor {
  border: 0px !important;
}

.content.order-list .form-group.has-label .el-input__inner {
  position: relative;
  top: 5px;
}
</style>
